module.exports = __webpack_public_path__ + "img/t2-9.7e5c314c.svg";